// API 응답에서 order 값 읽기 (snake_case / camelCase / Jackson getter 대문자 혼용 대응)
function getOrder(info, key) {
  const snake = info[`${key}_order`];
  if (snake !== undefined && snake !== null && snake !== '') return Number(snake);
  const camel = info[`${key}Order`];
  if (camel !== undefined && camel !== null && camel !== '') return Number(camel);
  const capitalO = info[`${key}_Order`];
  if (capitalO !== undefined && capitalO !== null && capitalO !== '') return Number(capitalO);
  return 0;
}

/**
 * 자주 쓰는 결재라인 상세 정보를 구성원 배열로 변환.
 * 기안자(sign1) 제외. 저장된 사용자 지정 순서(order 2, 3, 4, …) 그대로 복원만 함. 정렬 없음.
 */
export function mapSignLineMembers(info) {
  if (!info) return [];

  const byOrder = [];

  function addSlot(k, role) {
    const enumber = info[k];
    const order =
      role === '합의' ? (info.agreement_order ?? info.agreementOrder ?? 0) : getOrder(info, k);
    const numOrder = Number(order) || 0;
    if (enumber && enumber !== 0 && numOrder >= 2) {
      byOrder[numOrder] = {
        enumber,
        role,
        name: null,
        team: null,
        position: null,
        order: numOrder,
      };
    }
  }

  ['sign2', 'sign3', 'sign4', 'sign5'].forEach((k) => addSlot(k, '결재'));
  ['check1', 'check2', 'check3', 'check4'].forEach((k) => addSlot(k, '검토'));
  addSlot('agreement', '합의');

  // 사용자 지정 순서(order 2, 3, 4, …) 그대로 차례대로 복원. 정렬 없음.
  const result = [];
  for (let ord = 2; ord < byOrder.length; ord += 1) {
    if (byOrder[ord]) result.push(byOrder[ord]);
  }
  return result;
}
